import { cloneDeep } from 'lodash';

import { IWizardSubContentComponent } from './wizard.subcontent';
import { IWizardContentComponent, IValueChangedEvent } from './wizard.content';

export abstract class WizardComponent {
  createContentComponent(): void {
    const id = this.getWizardService().currentStep.config.def.template;
    const cType = this.resolveComponentType(id);
    const factory = this.getFactoryResolver().resolveComponentFactory(cType);
    this.getContentViewRef().clear();
    const component = this.getContentViewRef().createComponent(factory);
    const casted = component.instance as IWizardContentComponent;

    casted.step = this.getWizardService().currentStep;
    casted.subStep = this.getWizardService().templateModel;
    casted.wizardCtrl = this;
    casted.componentId = id;
    // notice I'm cloning value to give access to full object/but without ability to mess with the content of original stuff.
    casted.previousOutput = cloneDeep(casted.step.parent.output);
    casted.stateHistory = (componentId, inputId) => {
      const stateId = this.buildInputIdentifier(componentId, inputId);
      return casted.step.stateOfExtendedControls[stateId];
    };

    if (casted.onDataValueChange) {
      casted.onDataValueChange.subscribe(event =>
        this.onDataValueChangeListener(casted.step, event)
      );
    }
    if (casted.onMetaDataValueChange) {
      casted.onMetaDataValueChange.subscribe(event =>
        this.onMetaDataValueChangeListener(casted.step, event)
      );
    }
  }

  createSubContentComponent(): void {
    const id = this.getWizardService().currentStep.config.def.subTemplate;
    const cType = this.resolveComponentType(id);
    const factory = this.getFactoryResolver().resolveComponentFactory(cType);
    this.getSubContentViewRef().clear();
    const component = this.getSubContentViewRef().createComponent(factory);
    const casted = component.instance as IWizardSubContentComponent;
    casted.step = this.getWizardService().currentStep;
    casted.subStep = this.getWizardService().templateModel;
    casted.wizardCtrl = this;
    casted.componentId = id;

    if (casted.onDataValueChange) {
      casted.onDataValueChange.subscribe(event =>
        this.onDataValueChangeListener(casted.step, event)
      );
    }
    if (casted.onMetaDataValueChange) {
      casted.onMetaDataValueChange.subscribe(event =>
        this.onMetaDataValueChangeListener(casted.step, event)
      );
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  onDataValueChangeListener(currentStep: any, event: IValueChangedEvent): void {
    currentStep.dataValueChange(
      this.buildInputIdentifier(event.componentId, event.inputId),
      event.key,
      event.newValue,
      event.isValid
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  onMetaDataValueChangeListener(currentStep: any, event: IValueChangedEvent): void {
    currentStep.metaDataValueChange(
      this.buildInputIdentifier(event.componentId, event.inputId),
      event.key,
      event.newValue,
      event.isValid
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  buildInputIdentifier(componentId: any, inputId?: any): string {
    return `${componentId}/${inputId}`;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  abstract getWizardService();
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  abstract getFactoryResolver();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/explicit-module-boundary-types
  abstract resolveComponentType(templateId: any);
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  abstract getContentViewRef();
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  abstract getSubContentViewRef();
}
